/* eslint-disable flowtype/require-parameter-type */
/* eslint-disable flowtype*/
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable flowtype/require-valid-file-annotation */

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    modal: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.grey['50'],
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        maxWidth: '50%',
    },
    button: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));

export default useStyles;
